module EEX.McEc.Commands {

    export class GetKeyPairFromFileCommand {

        public execute(keyPairFile: string, certificateFile: string, keyPairPassword: string, success: (store: Pki.Store) => void,
            error: () => void,
            errorWrongPassword: () => void,
            errorPrivateKeyAndCertificateNotMatch: () => void) {
            let store = new Pki.Store();
            store.setCertificateFromFile(certificateFile);
            let wasSuccessful = store.setPrivateKeyPem(keyPairFile, keyPairPassword);
            if (!(wasSuccessful instanceof Pki.Error)) {
                success(store);
            } else {
                if (wasSuccessful.type === Pki.ErrorType.EncryptedPrivateKeyInvalid) {
                    error();
                } else if (wasSuccessful.type === Pki.ErrorType.EncryptedPrivateKeyInvalidPassword) {
                    errorWrongPassword();
                } else if (wasSuccessful.type === Pki.ErrorType.EncryptedPrivateKeyInvalidPrivateKeyNotMatchWithCertificate) {
                    errorPrivateKeyAndCertificateNotMatch();
                }
            }
        }
    }
}
